import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useMutation } from '@apollo/client';
import { message } from 'antd';
import ProjectHeader from '../../ProjectHeader';
import { ADD_VIREMENT, GET_VIREMENTS } from '../../../../gql/virements';
import { GET_BUDGET } from '../../../../gql/budgets';
import VirementForm from '../components/VirementForm';
import VirementSteps from '../components/VirementSteps';
import { PageContainer } from '@ant-design/pro-layout';

const AddVirement = () => {
  const { projectId } = useParams();
  const history = useHistory();
  const [addVirement] = useMutation(ADD_VIREMENT, {
    refetchQueries: ({
      data: {
        addVirement: { fromBudget, toBudget },
      },
    }) => [
      {
        query: GET_VIREMENTS,
        variables: {
          projectIds: [projectId],
          status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
        },
      },
      {
        query: GET_BUDGET,
        variables: {
          ids: [fromBudget.id, toBudget.id],
          virementStatus: [
            'DRAFT',
            'PENDING',
            'APPROVED',
            'REJECTED',
            'VOIDED',
          ],
        },
      },
    ],
    onCompleted: ({ addVirement: { id } }) => {
      message.success(`Virement saved`);
      history.push(`/projects/${projectId}/budget-virement/virements/${id}`);
    },
  });
  const onFinish = ({ fromBudget, toBudget, amount }) => {
    addVirement({
      variables: {
        input: {
          projectId,
          fromBudget,
          toBudget,
          amount,
        },
      },
    });
  };

  return (
    <ProjectHeader>
      <PageContainer>
        <VirementSteps current={0} />
        <VirementForm onFinish={onFinish} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default AddVirement;
